/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EventStatusEnum } from './EventStatusEnum';
import {
    EventStatusEnumFromJSON,
    EventStatusEnumFromJSONTyped,
    EventStatusEnumToJSON,
    EventStatusEnumToJSONTyped,
} from './EventStatusEnum';
import type { MainEventStatusEnum } from './MainEventStatusEnum';
import {
    MainEventStatusEnumFromJSON,
    MainEventStatusEnumFromJSONTyped,
    MainEventStatusEnumToJSON,
    MainEventStatusEnumToJSONTyped,
} from './MainEventStatusEnum';

/**
 * Emission Event serializer, used to display table and boards.
 * @export
 * @interface EmissionEvent
 */
export interface EmissionEvent {
    /**
     * 
     * @type {string}
     * @memberof EmissionEvent
     */
    readonly id: string;
    /**
     * 
     * @type {number}
     * @memberof EmissionEvent
     */
    owner: number;
    /**
     * 
     * @type {string}
     * @memberof EmissionEvent
     */
    readonly ownerName: string;
    /**
     * 
     * @type {string}
     * @memberof EmissionEvent
     */
    mainEmissionRecord: string;
    /**
     * 
     * @type {string}
     * @memberof EmissionEvent
     */
    mainEvent?: string | null;
    /**
     * 
     * @type {MainEventStatusEnum}
     * @memberof EmissionEvent
     */
    readonly mainEventStatus: MainEventStatusEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof EmissionEvent
     */
    linkedEvents: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof EmissionEvent
     */
    responsible?: number | null;
    /**
     * 
     * @type {string}
     * @memberof EmissionEvent
     */
    readonly responsibleName: string;
    /**
     * 
     * @type {number}
     * @memberof EmissionEvent
     */
    reviewer?: number | null;
    /**
     * 
     * @type {string}
     * @memberof EmissionEvent
     */
    readonly reviewerName: string;
    /**
     * 
     * @type {EventStatusEnum}
     * @memberof EmissionEvent
     */
    eventStatus: EventStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof EmissionEvent
     */
    extraNotes?: string;
    /**
     * 
     * @type {any}
     * @memberof EmissionEvent
     */
    formData?: any | null;
    /**
     * 
     * @type {Date}
     * @memberof EmissionEvent
     */
    readonly createdAt: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof EmissionEvent
     */
    readonly updatedAt: Date | null;
}



/**
 * Check if a given object implements the EmissionEvent interface.
 */
export function instanceOfEmissionEvent(value: object): value is EmissionEvent {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('owner' in value) || value['owner'] === undefined) return false;
    if ((!('ownerName' in (value as Record<string, any>)) && !('owner_name' in (value as Record<string, any>))) || ((value as Record<string, any>)['ownerName'] === undefined && (value as Record<string, any>)['owner_name'] === undefined)) return false;
    if ((!('mainEmissionRecord' in (value as Record<string, any>)) && !('main_emission_record' in (value as Record<string, any>))) || ((value as Record<string, any>)['mainEmissionRecord'] === undefined && (value as Record<string, any>)['main_emission_record'] === undefined)) return false;
    if ((!('mainEventStatus' in (value as Record<string, any>)) && !('main_event_status' in (value as Record<string, any>))) || ((value as Record<string, any>)['mainEventStatus'] === undefined && (value as Record<string, any>)['main_event_status'] === undefined)) return false;
    if ((!('linkedEvents' in (value as Record<string, any>)) && !('linked_events' in (value as Record<string, any>))) || ((value as Record<string, any>)['linkedEvents'] === undefined && (value as Record<string, any>)['linked_events'] === undefined)) return false;
    if ((!('responsibleName' in (value as Record<string, any>)) && !('responsible_name' in (value as Record<string, any>))) || ((value as Record<string, any>)['responsibleName'] === undefined && (value as Record<string, any>)['responsible_name'] === undefined)) return false;
    if ((!('reviewerName' in (value as Record<string, any>)) && !('reviewer_name' in (value as Record<string, any>))) || ((value as Record<string, any>)['reviewerName'] === undefined && (value as Record<string, any>)['reviewer_name'] === undefined)) return false;
    if ((!('eventStatus' in (value as Record<string, any>)) && !('event_status' in (value as Record<string, any>))) || ((value as Record<string, any>)['eventStatus'] === undefined && (value as Record<string, any>)['event_status'] === undefined)) return false;
    if ((!('createdAt' in (value as Record<string, any>)) && !('created_at' in (value as Record<string, any>))) || ((value as Record<string, any>)['createdAt'] === undefined && (value as Record<string, any>)['created_at'] === undefined)) return false;
    if ((!('updatedAt' in (value as Record<string, any>)) && !('updated_at' in (value as Record<string, any>))) || ((value as Record<string, any>)['updatedAt'] === undefined && (value as Record<string, any>)['updated_at'] === undefined)) return false;
    return true;
}

export function EmissionEventFromJSON(json: any): EmissionEvent {
    return EmissionEventFromJSONTyped(json, false);
}

export function EmissionEventFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmissionEvent {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'owner': json['owner'],
        'ownerName': json['owner_name'],
        'mainEmissionRecord': json['main_emission_record'],
        'mainEvent': json['main_event'] === undefined ? undefined : json['main_event'] === null ? null : json['main_event'],
        'mainEventStatus': MainEventStatusEnumFromJSON(json['main_event_status']),
        'linkedEvents': json['linked_events'],
        'responsible': json['responsible'] === undefined ? undefined : json['responsible'] === null ? null : json['responsible'],
        'responsibleName': json['responsible_name'],
        'reviewer': json['reviewer'] === undefined ? undefined : json['reviewer'] === null ? null : json['reviewer'],
        'reviewerName': json['reviewer_name'],
        'eventStatus': EventStatusEnumFromJSON(json['event_status']),
        'extraNotes': json['extra_notes'] == null ? undefined : json['extra_notes'],
        'formData': json['form_data'] === undefined ? undefined : json['form_data'] === null ? null : json['form_data'],
        'createdAt': (json['created_at'] == null ? null : new Date(json['created_at'])),
        'updatedAt': (json['updated_at'] == null ? null : new Date(json['updated_at'])),
    };
}

export function EmissionEventToJSON(json: any): EmissionEvent {
    return EmissionEventToJSONTyped(json, false);
}

export function EmissionEventToJSONTyped(value?: Omit<EmissionEvent, 'id'|'ownerName'|'mainEventStatus'|'responsibleName'|'reviewerName'|'createdAt'|'updatedAt'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'owner': value['owner'],
        'main_emission_record': value['mainEmissionRecord'],
        'main_event': value['mainEvent'],
        'linked_events': value['linkedEvents'],
        'responsible': value['responsible'],
        'reviewer': value['reviewer'],
        'event_status': EventStatusEnumToJSON(value['eventStatus']),
        'extra_notes': value['extraNotes'],
        'form_data': value['formData'],
    };
}

